// extracted by mini-css-extract-plugin
export var avatarContainer = "_5j-0";
export var avatarTypingWave = "_5j-i";
export var gray = "_5j-f";
export var green = "_5j-c";
export var icon = "_5j-9";
export var image = "_5j-1";
export var lg = "_5j-6";
export var md = "_5j-5";
export var presenceDot = "_5j-b";
export var red = "_5j-d";
export var sm = "_5j-4";
export var status = "_5j-a";
export var typingDot = "_5j-h";
export var typingPill = "_5j-g";
export var xl = "_5j-7";
export var xs = "_5j-3";
export var xxl = "_5j-8";
export var xxs = "_5j-2";
export var yellow = "_5j-e";